import { render, staticRenderFns } from "./HomeCommitment.vue?vue&type=template&id=53462fc6"
var script = {}
import style0 from "./HomeCommitment.vue?vue&type=style&index=0&id=53462fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports